<template>
  <v-container class="py-0 px-5">
    <v-row>
      <v-col
        cols="12"
        md="3"
      >
        <validated-text-field
          v-model="report.name"
          field-name="name"
          rules="required"
          type="text"
        />
      </v-col>
      <v-col
        cols="12"
        md="3"
      >
        <data-selector
          v-model="report.category_id"
          autofocus
          field-name="category_id"
          source-type="report-categories"
          translate
        />
      </v-col>
      <v-col
        cols="12"
        md="3"
      >
        <v-checkbox
          v-model="report.global"
          :label="$t('fields.global')"
          md="4"
        />
      </v-col>
      <v-col
        cols="12"
        md="3"
      >
        <v-checkbox
          v-model="report.translation"
          :label="$t('fields.translation_columns')"
          md="4"
        />
      </v-col>
    </v-row>
    <v-row>
      <v-col
        cols="12"
        md="6"
      >
        {{ $t('fields.query') }}
        <v-textarea
          v-model="report.query"
          clearable
          outlined
          clear-icon="mdi-close-circle"
          height="400"
        />
      </v-col>
      <v-col
        cols="12"
        md="6"
      >
        {{ $t('fields.params') }}
        <v-textarea
          v-model="report.params"
          clearable
          outlined
          clear-icon="mdi-close-circle"
          height="400"
        />
      </v-col>
    </v-row>
    <v-row>
      <v-col
        cols="12"
        md="6"
      >
        {{ $t('fields.description') }}
        <v-textarea
          v-model="report.description"
          clearable
          outlined
          clear-icon="mdi-close-circle"
        />
      </v-col>
      <v-col
        cols="12"
        md="6"
      >
        {{ $t('fields.export_format') }}
        <v-textarea
          v-model="report.formats"
          clearable
          outlined
          clear-icon="mdi-close-circle"
          height="400"
        />
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
  export default {
    name: 'EditReport',
    props: {
      report: Object,
    },
  }
</script>
